import {
  ACTION_ADD_SITE_ARTICLES,
} from '../actionTypes';


export const actionAddSiteArticles = siteArticles => ({
  type: ACTION_ADD_SITE_ARTICLES,
  payload: { siteArticles },
});
